import React, { useEffect, useState } from "react";
import ListItem from "./ListItem";
import BubbleChart from "../../atoms/BubbleChart";
import { getDashboardDemands } from "../../../utils/API/getDashboardDemands";
import { Skeleton } from "antd";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";

const MostDemanded = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [dataRange, setDataRange] = useState(null)

  useEffect(() => {
          // wrong error handling
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getDashboardDemands(dispatch);
        setDataRange(data[0].data_range);
        const response = data[0].credits;
        const topCredits = response.sort((a, b) => a.rank - b.rank);
        setData(topCredits);
      } catch (error) {
        toast.error(error.message);
        setError("Failed to fetch data");
        // setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (error)
    return (
      <div className="w-full shadow-custom bg-white p-4 gap-4 text-red-500 font-semibold text-xl rounded-2xl mt-4 h-[17.4rem] flex justify-center items-center">
        <LoadingOutlined />
        <p>Data not found!!</p>
      </div>
    );
  return (
    <div className="w-full shadow-custom bg-white p-4 rounded-2xl mt-4">
      <div className="flex justify-between">
        <div className="text-base font-bold mb-5 ml-2">
          Top 5 Credits - In Demand
        </div>
        <div className="text-[10px] text-grey-500 font-medium">
          {dataRange}
        </div>
      </div>
      <div className="flex">
        <ol className="list-none w-[50%]">
          {!loading ? (
            data.map((item, index) => (
              <ListItem key={`list-data-${index}`} index={index}>
                {item.name}
              </ListItem>
            ))
          ) : (
            <div className="pr-4">
              <Skeleton.Button
                block={true}
                active={true}
                style={{ marginBottom: "1rem", marginTop: "1rem" }}
              />
              <Skeleton.Button
                block={true}
                active={true}
                style={{ marginBottom: "1rem" }}
              />
              <Skeleton.Button
                block={true}
                active={true}
                style={{ marginBottom: "1rem" }}
              />
            </div>
          )}
        </ol>
        <div className="w-[50%] h-full">
          {!loading ? (
            <BubbleChart data={data} />
          ) : (
            <Skeleton.Button
              block={true}
              active={true}
              style={{ width: "100%", height: "12rem" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MostDemanded;
